<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <base-input label="Amount Pending">{{
          (sale.total - sale.amountPaid) | currency
        }}</base-input>
      </div>
    </div>
    <hr />
    <form class="needs-validation" @submit.prevent="firstFormSubmit">
      <div class="form-row">
        <div class="col-md-6">
          <base-input label="Date">
            <el-date-picker
              v-model="saleTransaction.date"
              type="date"
              placeholder="Pick a day"
            />
          </base-input>
          <base-input label="Payment Mode">
            <el-select v-model="saleTransaction.paymentModeId">
              <el-option
                v-for="(item, index) in paymentModes"
                :key="index"
                :value="item.paymentModeId"
                :label="item.label"
              />
            </el-select>
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input
            v-validate="'required'"
            v-model="saleTransaction.amount"
            :error="getError('Amount Paying')"
            :valid="isValid('Amount Paying')"
            label="Amount Paying"
            name="Amount Paying"
          />

          <base-input
            v-model="saleTransaction.paymentNote"
            label="Payment Note"
          />
        </div>
      </div>
      <base-button
        md
        :disabled="saleTransaction.amount === 0 ? true : false"
        :class="{ disabled: saleTransaction.amount === 0 }"
        type="primary"
        native-type="submit"
        >Save</base-button
      >
    </form>
    <el-table
      :data="saleTransactions"
      class="table-responsive table-flush sales-table"
      header-row-class-name="thead-light"
      style="margin-top : 20px;"
    >
      <el-table-column label="Date">
        <template slot-scope="scope">{{
          scope.row.date | convertDate
        }}</template>
      </el-table-column>
      <el-table-column label="Amount" prop="amount" />
      <el-table-column label="Payment Mode">
        <template slot-scope="scope">
          <span v-if="scope.row.paymentMode">{{
            scope.row.paymentMode.label
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Payment Note">
        <template slot-scope="scope">
          <span>{{ scope.row.paymentNote }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { Select, Option, Table, TableColumn, DatePicker } from "element-ui";
import { format } from "date-fns";
export default {
  filters: {
    convertDate(date) {
      return format(date, "YYYY-MM-DD");
    },
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    }
  },
  data: () => {
    return {
      date: new Date(),
      amount: "",
      paymentModeId: "",
      validated: false
    };
  },

  mounted() {
    this.getPaymentModes();
  },

  computed: {
    ...mapState("sale", ["saleTransaction"]),

    ...mapGetters({
      saleTransactions: "sale/getSaleTransactions",
      sale: "sale/getSale",
      paymentModes: "paymentMode/getPaymentModes",
      user: "user/getLoggedInUser"
    })
  },

  methods: {
    ...mapActions({
      getPaymentModes: "paymentMode/getPaymentModes",
      createSaleTransaction: "sale/createSaleTransaction",
      getSaleTransactions: "sale/getSaleTransactions",
      getSales: "sale/getSales"
    }),

    ...mapMutations({
      resetSaleTransaction: "sale/resetSaleTransaction"
    }),

    async firstFormSubmit() {
      try {
        await this.$validator.validateAll();
      } finally {
        this.validated = true;
        if (this.errors.items.length === 0) {
          this.onSubmit();
        }
      }
    },
    getError(name) {
      return this.errors.first(name);
    },
    isValid(name) {
      return this.validated && !this.errors.has(name);
    },

    onSubmit() {
      this.saleTransaction.createdBy = this.user.userId;
      this.saleTransaction.previouslyPaidAmount = this.sale.amountPaid;
      this.createSaleTransaction(this.sale.saleId).then(res => {
        this.$emit("close");
        this.resetSaleTransaction();
        this.$notify({
          message: "sale transaction is save successfully",
          type: "success",
          title: "Success"
        });
        this.getSaleTransactions(this.sale.saleId);
        this.getSales();
      });
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker
  }
};
</script>
